import { Component } from '@angular/core';

@Component({
  selector: 'app-download-section',
  standalone: true,
  imports: [],
  templateUrl: './download-section.component.html',
  styleUrl: './download-section.component.css'
})
export class DownloadSectionComponent {

}
